import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function muteConsole(): void {
  console.log = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    // Muta os logs só APÓS o bootstrap: não escondemos falhas de inicialização
    // (ficam visíveis via inspetor)
    if (environment.production) {
      muteConsole();
    }
  })
  .catch((err) => {
    // Erro fatal de bootstrap: registra no console (visível só via inspetor remoto)
    console.error(err);
  });
